export default "__VITE_ASSET__DKGzWWg5__"